/**
 * The web session of each camera, by camera id. Every session is its own origin, where the camera
 * keeps the operator's login, so a session is kept and reused while it lasts. The server makes a
 * session only as the answer to a request, so the container that asks for it writes the member.
 */

import { atom, type PrimitiveAtom } from 'jotai';
import { atomFamily } from 'jotai-family';

import type { DeviceWebSession } from '@/types/devices';

export const deviceWebSessionAtom = atomFamily(
    (_cameraId: string): PrimitiveAtom<DeviceWebSession | null> =>
        atom<DeviceWebSession | null>(null));

/** Stores the answer of a web session request under its camera. */
export const answerDeviceWebSessionAtom = atom(
    null,
    (_get, set, answer: { cameraId: string; session: DeviceWebSession }): void => {
        set(deviceWebSessionAtom(answer.cameraId), answer.session);
    });
